// extracted by mini-css-extract-plugin
export default {"dropdownContent":"ContextMenu_dropdownContent__Xj7ez"};